import { UiValuePropModel } from "../../models";

export function mockUiValuePropModel({
    id = "value-prop-1234",
    type = "uiValueProp",
    locale = "en",
    content = mockUiValuePropModelContent()
}: Partial<UiValuePropModel> = {}): UiValuePropModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiValuePropModelContent = UiValuePropModel["content"];

export function mockUiValuePropModelContent({
    ...optionals
}: Partial<UiValuePropModelContent> = {}): UiValuePropModelContent {
    return {
        ...optionals
    };
}
